/* Shopify-only boundary. The catalog-sheet configurator core must pass a validated configuration. */
window.MiraCharmCartAdapter = (() => {
  const variantFor = (variants, charmCount) => variants[String(charmCount)] || null;
  function propertiesFor(config) {
    const properties = { Chain: config.chain, Length: config.length, 'Charm Count': String(config.charmCount) };
    config.charms.forEach((id, index) => { properties[`Charm ${index + 1}`] = `#${id}`; });
    if (config.initial) properties.Initial = config.initial;
    return properties;
  }
  function verify(config, variants) {
    const variant = variantFor(variants, config.charmCount);
    if (!variant || !variant.available) throw new Error('This charm-count option is unavailable.');
    if (!Number.isInteger(config.expectedPriceCents) || config.expectedPriceCents !== variant.priceCents) {
      throw new Error('Configuration price does not match the Shopify variant price.');
    }
    if (config.charms.length !== config.charmCount || config.charms.some(id => !id)) throw new Error('Complete each charm position before adding to cart.');
    return variant;
  }
  async function add(config, variants) {
    const variant = verify(config, variants);
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:variant.id, quantity:1, properties:propertiesFor(config)}]})
    });
    let payload; try { payload = await response.json(); } catch { throw new Error('Shopify returned an unreadable cart response.'); }
    if (!response.ok) throw new Error(payload.description || payload.message || 'Shopify could not add this necklace to cart.');
    window.dispatchEvent(new CustomEvent('mira:cart-added',{detail:payload}));
    return payload;
  }
  return { variantFor, propertiesFor, verify, add };
})();
